import { render, staticRenderFns } from "./CardPost.vue?vue&type=template&id=0bd1ce11&scoped=true&"
import script from "./CardPost.vue?vue&type=script&lang=js&"
export * from "./CardPost.vue?vue&type=script&lang=js&"
import style0 from "./CardPost.vue?vue&type=style&index=0&id=0bd1ce11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1ce11",
  null
  
)

export default component.exports